import React from 'react'
import "./LandingPage.css"
import Navbar from '../components/layout/Navbar'
import Footer2 from '../components/layout/Footer2'
import {useHistory} from 'react-router-dom'
import {Button} from 'antd'




function LandingPage() {
    const history = useHistory()

    return (
        <>
        <div>
           <Navbar />
           <div className='header' style={{paddingLeft: '50px'}}>
           <h4 className='main-head'>Old Mutual<br />
            Customer Consent</h4>               
            <p className='head-text' style={{color: 'white', fontWeight: '200'}}>This platform will allow you to consent to receiving information and gaining <br /> access  to products and services across all Old Mutual Group Companies.</p>
            <p className='head-text' style={{color: 'white', fontWeight: '200'}}>This will help us to,</p>
        <ul style={{marginTop: '20px', color: 'white', fontSize: '13px'}} className='head-ul'>
                        <li>Better understand your needs and expectations, making it easier to tailor <br/> our products and services to meet, manage and exceed your expectations.</li>
                        <li>Improve our service delivery channels – both online and offline - in meeting <br/> your unique financial needs.</li>
                        <li>Personalise your experience with our brand and products, ensuring that the <br/>experience you have is unique and suited to you.</li>
                        <li>Increase our ability to engage and communicate with you for updates, <br/>opportunities, and promotional offers.</li>
        </ul>
        <a href='https://www.oldmutual.co.zw/about-us/privacy-policy/'><p className='head-text' style={{color: 'white', fontWeight: '200', fontSize: '13px'}}><u>Learn more about how we protect your data.</u></p> </a>
  <div style={{ display: 'flex', flexDirection: 'column'}}>
  <div className='textBelowButtons'>  
  <p className='head-text' style={{color: 'white', fontWeight: '200', fontSize: '12px', marginRight: '3%'}}>
  First time accessing the platform? <br/>Please register to create a profile.
  </p>
  <p className='head-text' style={{ color: 'white', fontWeight: '200', fontSize: '12px', marginBottom: '10px'}}>
   Already have a profile on this platform?<br/> Please log in to proceed. 
  </p>
  </div>
  
  <div style={{ display: 'flex', flexDirection: 'row'}}>
    <Button
      className='landingBtn'
      onClick={() => { history.push("/register") }}
      type="primary"
      size="large"
      style={{
        width: '250px',
        height: '50px',
        borderRadius: '100px',
        borderColor: '#47AE57',
        fontSize: '16px',
        backgroundColor: '#47AE57',
        color: "white",
      }}
    >
      Register <span style={{ marginLeft: '5px' }}>&#8594;</span>
    </Button>
    
    <Button
      onClick={() => { history.push("/login") }}
      size="large"
      className='buttonLogin'
      style={{
        width: '250px',
        borderRadius: '100px',
        fontSize: '16px',
        color: "white",
        height: '50px',
        backgroundColor: 'black',
        borderColor: "white",
      }}
    >
      Login <span style={{ marginLeft: '5px' }}>&#8594;</span>
    </Button>
  </div>
</div>

        </div>
         
            {/* <div className='content' style={{display: 'flex'}}>
                <div className='content-body' style={{margin: 'auto'}}>
                  
                    <h3 style={{marginTop: '50px', color: '#282828'}} className='h3'>Your Consent Will Allow Old Mutual To</h3>
                    <ul style={{marginTop: '20px', color: '#282828'}} className='p'>
                        <li>Better understand your needs and expectations, making it easier to tailor our products and services to meet, manage and exceed your expectations.</li>
                        <li>Improve our service delivery channels – both online and offline - in meeting your unique financial needs.</li>
                        <li>Personalise your experience with our brand and products, ensuring that the experience you have is unique and suited to you.</li>
                        <li>Increase our ability to engage and communicate with you for updates, opportunities, promotional offers.</li>
                    </ul>
                    <h3 style={{marginTop: '20px',  marginBottom: 50, color: '#282828', fontSize: '25px'}} className='h3'>NOTE: You can change your consent using this platform at any time.</h3>
                    <br/>
                </div>
            </div> */}
        </div>
        <Footer2 />
        </>

    )
}

export default LandingPage